<template>
    <div class="edit-button">
        <button class="button" title="Update" :value="text" @click.prevent="emitEdit">{{ text }}</button>
        <button class="button" style-color="grey" v-if="editing" @click.prevent="emitCancel">Cancel</button>
    </div>
</template>

<script>
    export default {
        name: "EditableButton",
        data() {
            return {
                editing: false
            }
        },
        computed: {
            text() {
                return this.editing ? 'Save' : 'Edit'
            }
        },
        methods: {
            emitEdit() {
                this.$parent.$emit('editAll', {editing: this.editing});
            },
            emitCancel() {
                let editing = this.editing;
                this.$parent.$emit('editAll', {editing: editing, cancel: true})
            }
        }
    }
</script>

<style scoped>

</style>
